import { dashboardT } from '../../../../../lib/messages';
import { resolveCampaignStatusLabel, type CampaignStatus } from '../../model';

/** Adds or removes one status from the filter, keeping the existing order and no duplicates. */
export function toggleCampaignStatus(
  statuses: readonly CampaignStatus[],
  status: CampaignStatus,
  checked: boolean,
): CampaignStatus[] {
  return checked
    ? Array.from(new Set([...statuses, status]))
    : statuses.filter((item) => item !== status);
}

/** Trigger label: the selected status labels, or "All statuses" when none is selected. */
export function campaignStatusFilterLabel(statuses: readonly CampaignStatus[]): string {
  return statuses.length
    ? statuses.map(resolveCampaignStatusLabel).join(', ')
    : dashboardT('campaigns.allStatuses');
}
